module.exports = __webpack_public_path__ + "src/assets/img/pic (8).c242bd11.jpg";